import { Box, Dialog, DialogTitle, IconButton, Backdrop, CircularProgress, Typography, Portal } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useEffect, useState, useRef } from "react";
import StickyNotesBoard from "./StickyNotesBoard";
import { REST_API_END_POINT } from "src/constants/Defaultvalues";
import axios from "axios";

export default function NoteStickyIndividualPopup() {
  const [openSticky, setOpenSticky] = useState(false);
  const [notes, setNotes] = useState([]);
  const userSession = JSON.parse(localStorage.getItem('user'));
  
  // 🚀 LOADING STATE: Simple loading state
  const [isLoading, setIsLoading] = useState(false);
  const isLoadingRef = useRef(false);
  const savingCountRef = useRef(0);
const fetchNotesL = async () => {
        try {
            const res = await axios.post(
                `${REST_API_END_POINT}tickets/get-all-sticky-notes-individual`,
                { userId: userSession?.user_id }
            );

            if (res.data?.status === 1 && Array.isArray(res.data.data)) {
                setNotes(res.data.data);
            } else if (res.data?.status === 1 && res.data.data) {
                setNotes([res.data.data]);
            } else {
                setNotes([]);
            }
        } catch (err) {
            console.error("Failed to fetch sticky notes", err);
        }
    };
    useEffect(() => {
        fetchNotesL();
    }, []);

    // Reset loading state when dialog opens
    useEffect(() => {
        if (openSticky) {
            console.log('Dialog opened, resetting loading state');
            setIsLoading(false);
            isLoadingRef.current = false;
            savingCountRef.current = 0; // Reset saving count
        }
    }, [openSticky]);

    // Update ref when loading state changes
    useEffect(() => {
        isLoadingRef.current = isLoading;
    }, [isLoading]);

    // Function to manage saving count
    const startSaving = () => {
        savingCountRef.current += 1;
        console.log('Starting save, count:', savingCountRef.current);
        setIsLoading(true);
    };

    const finishSaving = () => {
        savingCountRef.current = Math.max(0, savingCountRef.current - 1);
        console.log('Finishing save, count:', savingCountRef.current);
        if (savingCountRef.current === 0) {
            setIsLoading(false);
            console.log('Loading state cleared - setIsLoading(false)');
        }
    };
    const otherNotes = notes.filter((note) => note.added_by !== userSession?.user_id);


  return (
    <>
      <IconButton onClick={() => setOpenSticky(true)} sx={{ padding: 0, width: 44, height: 44, top: 3 }}>
        {/* <Box className="bi--sticky-fill" />  */}
       {otherNotes.length >0? <Box className="material-symbols--note-stack" />:<Box className="bi--sticky-fill" /> }
      </IconButton>

      <Dialog open={openSticky} onClose={async () => {
        // Don't close if already loading
        if (isLoading) return;
        
        // Check if there are unsaved changes before triggering auto-save
        const hasUnsavedChanges = window.hasUnsavedStickyChanges;
        if (hasUnsavedChanges) {
          // Trigger auto-save before closing
          const autoSaveEvent = new CustomEvent('autoSaveSticky');
          window.dispatchEvent(autoSaveEvent);
          // Wait for the save operation to complete
          setIsLoading(true);
          // Wait for loading to finish (save operation complete) - NO TIMEOUT
          const checkLoading = () => {
            return new Promise((resolve) => {
              const interval = setInterval(() => {
                if (!isLoadingRef.current) {
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
            });
          };
          await checkLoading();
        }
        // Reset global flags when closing
        window.hasUnsavedStickyChanges = false;
        window.sharingStickyNote = false;
        window.archivingStickyNote = false;
        window.unarchivingStickyNote = false;
        setOpenSticky(false);
      }} maxWidth="md" fullWidth>
        <DialogTitle sx={{ pl: 2.4, pr: 3, pb: 2, pt: 2 }}>
          Sticky Note
          <IconButton
            onClick={async () => {
              // Don't close if already loading
              if (isLoading) return;
              
              // Check if there are unsaved changes before triggering auto-save
              const hasUnsavedChanges = window.hasUnsavedStickyChanges;
              if (hasUnsavedChanges) {
                // Trigger auto-save before closing
                const autoSaveEvent = new CustomEvent('autoSaveSticky');
                window.dispatchEvent(autoSaveEvent);
                // Wait for the save operation to complete
                setIsLoading(true);
                // Wait for loading to finish (save operation complete) - NO TIMEOUT
                const checkLoading = () => {
                  return new Promise((resolve) => {
                    const interval = setInterval(() => {
                      if (!isLoadingRef.current) {
                        clearInterval(interval);
                        resolve();
                      }
                    }, 100);
                  });
                };
                await checkLoading();
              }
              // Reset global flags when closing
              window.hasUnsavedStickyChanges = false;
              window.sharingStickyNote = false;
              window.archivingStickyNote = false;
              window.unarchivingStickyNote = false;
              setOpenSticky(false);
            }}
            onDoubleClick={() => {
              // Force close on double-click - clear loading state and close dialog
              setIsLoading(false);
              isLoadingRef.current = false;
              savingCountRef.current = 0;
              window.sharingStickyNote = false;
              window.hasUnsavedStickyChanges = false;
              window.archivingStickyNote = false;
              window.unarchivingStickyNote = false;
              setOpenSticky(false);
            }}
            disabled={isLoading}
            sx={{ position: 'absolute', right: 12, top: 8, color: (theme) => theme.palette.grey[500] }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <Box sx={{ 
          minHeight: '500px',
          overflowY: 'auto', 
          pl: 2, 
          pr: 2, 
          pb: 2,
          position: 'relative'
        }}>
          {/* 🚀 BACKGROUND CONTENT: Blur when loading */}
          <Box sx={{
            filter: isLoading ? 'blur(3px)' : 'none',
            transition: 'filter 0.3s ease'
          }}>
            <StickyNotesBoard 
              fetchNotesL={fetchNotesL} 
              onCloseDialog={() => {
                setOpenSticky(false)
                }}
              // 🚀 LOADING STATE: Pass loading state props
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              startSaving={startSaving}
              finishSaving={finishSaving}
            />
          </Box>
        </Box>

        {/* <Box sx={{ maxHeight: 'calc(100vh - 200px)', minHeight: '100px', overflowY: 'auto', pl: 2, pr: 2, pb: 2 }}>
  <StickyNotesBoard />
</Box> */}

      </Dialog>

      {/* 🚀 LOADING OVERLAY: Above entire dialog using Portal */}
      {isLoading && savingCountRef.current > 0 && (() => {
        console.log('Loading overlay triggered - isLoading:', isLoading, 'savingCount:', savingCountRef.current);
        return (
        <Portal>
          <Box sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(15px)',
            zIndex: 99999,
            gap: 2
          }}>
            <CircularProgress color="primary" size={40} />
            <Typography variant="h6" sx={{
              textAlign: 'center',
            }}>
              {savingCountRef.current > 1 
                ? `Saving ${savingCountRef.current} Sticky Notes...` 
                : (window.sharingStickyNote ? 'Sharing Sticky Note...' : 
                   window.archivingStickyNote ? 'Archiving Sticky Note...' :
                   window.unarchivingStickyNote ? 'Unarchiving Sticky Note...' : 'Saving Sticky Note...')
              }
            </Typography>
          </Box>
        </Portal>
        );
      })()}

    </>
  );
}
